import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const problems = ['Siempre acabas con el mismo tipo de hombre: sin compromiso, intermitente, que no te prioriza', 'Sientes que das más de lo que recibes en todas tus relaciones', 'Te preguntas constantemente "¿por qué no me eligen?"', 'Has probado terapia, libros, cursos... pero sigues repitiendo el mismo patrón', 'Por fuera pareces fuerte e independiente, pero por dentro dudas de tu valor', 'Tienes miedo de quedarte sola para siempre'];
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white text-center" data-id="element-122">
      <div className="max-w-3xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-124">
          <div className="text-4xl mb-4" data-id="element-125">💔</div>
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-10" data-id="element-126">
            "Te ha pasado que..."
          </h2>

          <div className="space-y-6 text-left max-w-2xl mx-auto mb-12" data-id="element-127">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start space-x-4 p-4 rounded-lg bg-beige-50 border border-beige-100" data-id="element-128">
                <div className="flex-shrink-0 mt-1" data-id="element-129">
                  <X className="w-5 h-5 text-red-400" data-id="element-130" />
                </div>
                <p className="text-gray-700 text-lg" data-id="element-131">{problem}</p>
              </motion.div>)}
          </div>

          <div className="inline-block bg-beige-100 py-3 px-6 rounded-full" data-id="element-132">
            <p className="text-lg font-semibold text-dark" data-id="element-133">
              Si has dicho que sí a{' '}
              <span className="text-gold-600" data-id="element-134">1 o más</span>, esto es para ti
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}